import { getIsoCodeForLocale } from '@micro-apps/env';

type formatPriceArgs = {
	currencyCode?: string;
	value?: string | number;
	locale?: string;
	useGrouping?: boolean;
	decimalPlaces?: number;
	removeCurrency?: boolean;
};

export default function formatPrice({
	currencyCode = 'USD',
	value: initialValue,
	locale = 'en',
	useGrouping = true,
	decimalPlaces = 2,
	removeCurrency = false,
}: formatPriceArgs = {}) {
	function innerFormatPrice(value) {
		//Check the format of the value provided - number preferred, but will accept and parse a string
		let price;
		if (typeof value === 'string') {
			price = Number.parseFloat(value);
		} else if (typeof value === 'number') {
			price = value;
		} else {
			return Error('Value is unsupported type');
		}

		// Returned if no currency is found rather than a default currency as will show incorrect price with another currency
		if (currencyCode === 'N/A') {
			return '-';
		}

		const formattedCurrency = Intl.NumberFormat(getIsoCodeForLocale(locale), {
			style: 'currency',
			currencyDisplay: 'code',
			currency: currencyCode,
			useGrouping,
			minimumFractionDigits: decimalPlaces,
			maximumFractionDigits: decimalPlaces,
		}).format(price);

		return removeCurrency ? formattedCurrency.replace(/[^0123456789.,]/g, '') : formattedCurrency;
	}

	return initialValue !== undefined ? innerFormatPrice(initialValue) : innerFormatPrice;
}
